"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _FillTextEffect2 = _interopRequireDefault(require("./FillTextEffect"));

var _isEmptyString = _interopRequireDefault(require("../../../utils/object/isEmptyString"));

var _Color = _interopRequireDefault(require("../../../models/Color"));

var _text = require("../../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_HIGHLIGHT_VALUES = _text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.HIGHLIGHT];

var LineFillTextEffect = /*#__PURE__*/function (_FillTextEffect) {
  (0, _inherits2["default"])(LineFillTextEffect, _FillTextEffect);

  var _super = _createSuper(LineFillTextEffect);

  function LineFillTextEffect() {
    (0, _classCallCheck2["default"])(this, LineFillTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(LineFillTextEffect, null, [{
    key: "compositeEffectContexts",
    value: function compositeEffectContexts(finalContext, effectContext) {
      var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      // Save the current transform, composite the two canvases with the given opacity, and restore the current transform and alpha
      finalContext.save();
      var originalOpacity = finalContext.globalAlpha;
      finalContext.setTransform(1, 0, 0, 1, 0, 0);
      finalContext.globalAlpha = opacity;
      finalContext.drawImage(effectContext.canvas, 0, 0, effectContext.canvas.width, effectContext.canvas.height, 0, 0, finalContext.canvas.width, finalContext.canvas.height);
      finalContext.restore();
      finalContext.globalAlpha = originalOpacity;
    }
  }, {
    key: "drawFitTextBox",
    value: function drawFitTextBox(finalContext, effectContext, contentFrameData) {
      var _this = this;

      var lines = contentFrameData.textLines,
          textRenderProperties = contentFrameData.textRenderProperties;
      var renderedFontSize = textRenderProperties.renderedFontSize,
          horizontalAlignment = textRenderProperties.horizontalAlignment,
          textEffect = textRenderProperties.textEffect;
      var alignmentY = this.getAlignmentY(contentFrameData);
      var opacity = textRenderProperties.textEffect.get('opacity') / 100;
      var padding = textEffect.get('boxPadding');
      var horizontalPadding = this.getHorizontalPadding(renderedFontSize);
      var totalPadding = padding + horizontalPadding;

      var _this$getMostLeftLine = this.getMostLeftLine(lines),
          mostLeftActualBoundingBoxLeft = _this$getMostLeftLine.actualBoundingBoxLeft,
          x = _this$getMostLeftLine.x;

      var mostLeftX = x - mostLeftActualBoundingBoxLeft;

      var _this$getMostRightLin = this.getMostRightLine(lines),
          mostRightBoundingBoxLeft = _this$getMostRightLin.actualBoundingBoxLeft,
          width = _this$getMostRightLin.width,
          mostRightLineX = _this$getMostRightLin.x;

      var mostRightX = mostRightLineX - mostRightBoundingBoxLeft + (width + totalPadding); // draw line fill boxes in to a separate canvas

      var fillColor = textEffect.get('color') || DEFAULT_HIGHLIGHT_VALUES.color;
      effectContext.fillStyle = _Color["default"].getColorFromHexColor(fillColor);
      var borderRadius = textEffect.get('borderRadius');
      lines.forEach(function (lineData) {
        var actualBoundingBoxLeft = lineData.actualBoundingBoxLeft,
            width = lineData.width,
            fontBoundingBoxAscent = lineData.fontBoundingBoxAscent,
            fontHeight = lineData.fontHeight,
            line = lineData.line,
            x = lineData.x,
            y = lineData.y;
        if ((0, _isEmptyString["default"])(line)) return;
        var lineX = x - actualBoundingBoxLeft - totalPadding;
        var lineFillBoxWidth = width + 2 * totalPadding;

        switch (horizontalAlignment) {
          case _text.TEXT_ALIGNMENT.RIGHT:
            lineFillBoxWidth += mostRightX - (lineX + lineFillBoxWidth);
            break;

          case _text.TEXT_ALIGNMENT.LEFT:
            lineX = mostLeftX - totalPadding;
            lineFillBoxWidth += mostLeftActualBoundingBoxLeft - actualBoundingBoxLeft;
            break;

          default:
            break;
        }

        var lineFillBoxHeight = fontHeight + 2 * padding;
        var lineY = alignmentY + y;
        var lineFillY = lineY - fontBoundingBoxAscent - padding;

        _this.fillRect(effectContext, lineX, lineFillY, lineFillBoxWidth, lineFillBoxHeight, borderRadius);
      });
      this.compositeEffectContexts(finalContext, effectContext, opacity);
    }
  }, {
    key: "drawTextBox",
    value: function drawTextBox(finalContext, effectContext, contentFrameData) {
      var _this2 = this;

      var lines = contentFrameData.textLines,
          textRenderProperties = contentFrameData.textRenderProperties;
      var renderedFontSize = textRenderProperties.renderedFontSize,
          textEffect = textRenderProperties.textEffect;
      var alignmentY = this.getAlignmentY(contentFrameData);
      var padding = textEffect.get('boxPadding');
      var opacity = textEffect.get('opacity') / 100;
      var horizontalPadding = this.getHorizontalPadding(renderedFontSize);

      var _this$getFillTextProp = this.getFillTextProperties(lines, padding),
          lineFillWidth = _this$getFillTextProp.lineFillWidth,
          lineFillX = _this$getFillTextProp.lineFillX; // draw line fill boxes on to a separate canvas


      var fillColor = textEffect.get('color') || DEFAULT_HIGHLIGHT_VALUES.color;
      effectContext.fillStyle = _Color["default"].getColorFromHexColor(fillColor);
      lines.forEach(function (lineData) {
        var fontBoundingBoxAscent = lineData.fontBoundingBoxAscent,
            fontHeight = lineData.fontHeight,
            line = lineData.line,
            y = lineData.y;
        if ((0, _isEmptyString["default"])(line)) return;
        var lineY = alignmentY + y;
        var lineFillBoxHeight = fontHeight + 2 * padding;
        var lineFillBoxWidth = lineFillWidth + 2 * horizontalPadding;
        var lineFillY = lineY - fontBoundingBoxAscent - padding;

        _this2.fillRect(effectContext, lineFillX - horizontalPadding, lineFillY, lineFillBoxWidth, lineFillBoxHeight, textEffect.get('borderRadius'));
      });
      this.compositeEffectContexts(finalContext, effectContext, opacity);
    }
  }, {
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      var textRenderProperties = contentFrameData.textRenderProperties;
      var textEffect = textRenderProperties.textEffect;

      switch (textEffect.get('size')) {
        case _text.HIGHLIGHT_SIZE_OPTIONS.LINE:
          this.drawTextBox(finalContext, effectContext, contentFrameData);
          break;

        case _text.HIGHLIGHT_SIZE_OPTIONS.TEXT:
        default:
          this.drawFitTextBox(finalContext, effectContext, contentFrameData);
          break;
      } // draw text over


      finalContext.fillStyle = textRenderProperties.fillColor;
      this.drawTextLines(finalContext, contentFrameData);
    }
  }]);
  return LineFillTextEffect;
}(_FillTextEffect2["default"]);

exports["default"] = LineFillTextEffect;